import { render, staticRenderFns } from "./MainEdit.vue?vue&type=template&id=9c06411e&scoped=true"
import script from "./MainEdit.vue?vue&type=script&lang=js"
export * from "./MainEdit.vue?vue&type=script&lang=js"
import style0 from "./MainEdit.vue?vue&type=style&index=0&id=9c06411e&prod&lang=css"
import style1 from "./MainEdit.vue?vue&type=style&index=1&id=9c06411e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c06411e",
  null
  
)

export default component.exports